import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components"
import ChevronDown from "../icons/chevronDown";


const AccordionContainer = styled.div`
  border-bottom: 1px solid #e2e2e2;
  border-radius: 4px;
`;

const AccordionTitle = styled.button`
  background-color: #fff;
  color: #333;
  cursor: pointer !important;
  padding: 1rem;
  width: 100%;
  border: none;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: text-decoration 0.4s ease;
  color: #183D63;
  font-size: 1.2rem;
  line-height: 2rem;
  position: relative;

  &:hover {
    text-decoration: underline;
  }

`;

const Rotate = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.4s;
  transform: rotate(${props => (props.isActive ? '180deg' : '0deg')});
`;

const AccordionContent = styled.div`
  padding: 0 1rem;
  overflow: hidden;
  transition: max-height 0.4s ease;
  color: rgb(113, 128, 150);
  font-size: 0.95rem;
`;

const Accordion = ({ title, children, isActive: initialActive }) => {
  const [isActive, setIsActive] = useState(initialActive);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      setContentHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setContentHeight('0px');
    }
  }, [isActive]);

  const [contentHeight, setContentHeight] = useState('0px');

  const handleToggle = () => {
    setIsActive(!isActive);
  };


  return (
    <AccordionContainer>
      <AccordionTitle onClick={handleToggle}>
        {title}
      <Rotate isActive={isActive}>
        <ChevronDown style={{ width: '1.3rem', height: '1.3rem', color: '#183D63' }} />
      </Rotate>
      </AccordionTitle>
      <AccordionContent
        ref={contentRef}
        style={{ maxHeight: `${contentHeight}` }}
      >
        {children}
      </AccordionContent>
    </AccordionContainer>
  );
};

export default Accordion;